import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

const VersionRedirectToV2 = ({ location }) => {
  const getV2Url = (currentPath) => {
    if (window.location.hostname === 'localhost') {
      return `http://localhost:5173${currentPath}`;

    } else if (window.location.hostname.includes('dev')) {
      return `https://matricula-pos-v2-dev.educacionalagos.com.br${currentPath}`;
    }

    return `https://matricula-pos-v2.educacionalagos.com.br${currentPath}`;
  }


  useEffect(() => {
    // Pega o token do state, se existir
    const token = localStorage.getItem('token') || null;

    if (token) {
      if (window.location.hostname === 'localhost') {
        document.cookie = `token=${token}; path=/;`;
      } else {
        document.cookie = `token=${token}; domain=.educacionalagos.com.br; path=/; secure;`;
      }
    }

    const currentPath = location.pathname + location.search;
    window.location.href = getV2Url(currentPath);

  }, [location]);

  return null;
};

export default withRouter(VersionRedirectToV2);
